import type { FormInstance } from '@arco-design/web-react';

import { setFieldValueIfChanged } from '../../common/formHelpers';

/** 换镜像时需清空的资源配置字段（架构 / CPU / 内存 / GPU 及计价元数据） */
export const IMAGE_LINKED_RESOURCE_COMPUTE_PATHS = [
  'system.architecture',
  'resource.cpu',
  'resource.memory',
  'resource.gpu',
  'resource.cpuPricing',
  'resource.memoryPricing',
  'resource.gpuPricing',
] as const;

export function clearImageLinkedResourceComputeFromForm(form: FormInstance, extraPaths: readonly string[] = []): void {
  for (const path of [...IMAGE_LINKED_RESOURCE_COMPUTE_PATHS, ...extraPaths]) {
    setFieldValueIfChanged(form, path, undefined);
  }
}
